import axios from '@/utils/request'

export default {
  getHotsearchList: (data) => axios({ url: '/api/product/hotTerm/terms', method: 'POST', data }), // 热搜词列表
  addHotsearchWords: (data) => axios({ url: '/api/product/hotTerm/term', method: 'POST', data }), // 新增热搜词
  editHotsearchWordsStatus: (data) => axios({ url: '/api/product/hotTerm/status', method: 'PUT', data }), // 修改热搜词状态
  setDragSort: (data) => axios({ url: '/api/product/dragOrder', method: 'PUT', data }) // 拖动排序
}
